// extracted by mini-css-extract-plugin
export default {"lottieContainer":"w5WJrR"};